<script>
	import { onMount } from "svelte";

	export let content;

	let touch = false;

	let active = false;
	let open = false;

	const mouseover = (e) => {
		if (touch) return;
		active = true;
		open = true;
	};
	const mouseout = (e) => {
		active = false;
		open = false;
	};
	const click = (e) => {
		active = !active;
	};

	onMount(() => {
		function checkTouch() {
			touch = true;
			document.removeEventListener("touchstart", checkTouch);
		}
		document.addEventListener("touchstart", checkTouch);
	});

	const stop = (e) => {
		active = false;
		e.stopPropagation();
		e.preventDefault();
		return false;
	};
</script>

<div class="infobox" class:active class:touch>
	<div class="icon" on:mouseover={mouseover} on:mouseout={mouseout} on:click={click}>
		<img src={`${PATH}assets/images/i.svg`} />
	</div>
	{#if active}
		<div class="content" on:mouseover={mouseover} on:touchstart={stop} on:click={stop}>
			{@html content}
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../main.scss";
	.infobox {
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
		user-select: none;
    position: relative;

    margin-right: -6px;
	}

	.icon {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		border: 6px solid transparent;

		img {
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	.content {
		position: absolute;
		padding: 23px 15px 30px 20px;
		z-index: 4;
		width: 285px;
		max-width: calc(100vw - 60px);
		background: #ffffff;
		box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.33);
		border-radius: 10px;
		font-weight: 400;
		font-size: 13px;
		line-height: 18px;
		letter-spacing: 0.015em;
		top: 28px;
		white-space: normal;

		@media (max-width: $breakpoint-tablet-l) {
			right: 0;
		}
	}

	.touch .content::before {
		content: " ";
		position: absolute;
		width: 2px;
		height: 12px;
		background: #5d5d5d;
		transform-origin: center center;
		top: 8px;
		right: 12px;
		transform: rotate(-45deg);
	}

	.touch .content::after {
		content: " ";
		position: absolute;
		width: 2px;
		height: 12px;
		background: #5d5d5d;
		transform-origin: center center;
		top: 8px;
		right: 12px;
		transform: rotate(45deg);
	}

	.content :global(.mark) {
		font-weight: 500;
	}
</style>
